import {ProductionCostKpis} from '@/Pages/ProductionCost/store/types';
import {getKmsOrMiles} from '@/Pages/Common/LabelUtils';
import {formatSmartRounded} from '@/services/formatters';
import {ReadOnlyKpiInputConfig} from '../hooks/useReadOnlyKpiInputConfigBuilder';

export const ProductionCostKpisConfig: {
  [K in keyof ProductionCostKpis]: ReadOnlyKpiInputConfig;
} = {
  totalDistance: {
    label: 'Total distance:',
    formatValue: (kpi, units) =>
      `${
        kpi.value === null ? 'N/A' : formatSmartRounded(kpi.value)
      } ${getKmsOrMiles(units)}`,
    id: 'production-cost-total-distance',
    order: 1
  },
  avgWeeklyOpDays: {
    label: 'Avg. operating days:',
    formatValue: kpi =>
      `${kpi.value === null ? 'N/A' : formatSmartRounded(kpi.value)} days/week`,
    id: 'production-cost-avg-weekly-op-days',
    order: 2
  },
  totalScheduleHours: {
    label: 'Total schedule hours:',
    formatValue: kpi =>
      `${kpi.value === null ? 'N/A' : formatSmartRounded(kpi.value)} hours`,
    id: 'production-cost-total-schedule-hours',
    order: 3
  },
  avgWeeklyDistancePerBus: {
    label: 'Avg. distance per bus:',
    formatValue: (kpi, units) =>
      `${
        kpi.value === null ? 'N/A' : formatSmartRounded(kpi.value)
      } ${getKmsOrMiles(units)}/week`,
    id: 'production-cost-avg-distance-per-bus',
    order: 4
  }
};
